import { apiFetch } from '@/lib/apiFetch';

export interface DemandSignalResponse {
  id: string;
  email: string;
  offeringType?: string | null;
  createdAt: string;
  message: string;
}

export async function captureDemandSignal(params: {
  email?: string;
  /** The offering type this Notify-Me is scoped to (per-type zero-result flow, ADR-088). */
  offeringType?: string;
  filterState: Record<string, unknown>;
  accessToken?: string;
}): Promise<DemandSignalResponse> {
  const headers: Record<string, string> = { 'Content-Type': 'application/json' };
  if (params.accessToken) {
    headers['Authorization'] = `Bearer ${params.accessToken}`;
  }
  const res = await apiFetch('/api/v1/marketplace/demand-signals', {
    method: 'POST',
    headers,
    body: JSON.stringify({ email: params.email, offeringType: params.offeringType, filterState: params.filterState }),
  });
  if (!res.ok) {
    throw new Error(`Failed to capture demand signal: ${res.status}`);
  }
  return res.json();
}
